
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puzzles/themes",
      function () {
        return require("private-next-pages/puzzles/themes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puzzles/themes"])
      });
    }
  